import { ref, onMounted } from 'vue';
export default {
  name: 'toastCom',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  setup() {
    const visible = ref(false);
    onMounted(() => {
      visible.value = true;
    });
    return {
      visible
    };
  }
};